import type {DashboardContext} from './dashboardContextBus';
/** Page scope of the Dashboard 2.0 context bus. Never publishes consultation values over STOMP. */
export function createDashboardPageContext(initial:DashboardContext = {}) {
 let context=initial;const listeners=new Set<()=>void>();
 return {snapshot:()=>context,subscribe:(listener:()=>void)=>{listeners.add(listener);return()=>{listeners.delete(listener);};},publish:(next:DashboardContext)=>{context={...next};listeners.forEach(listener=>listener());}};
}
